import { produce } from "../../../../../../../libs/immer";
import { inputEmailUseCase } from "./emailInput.case";
import { submitEmailUseCase } from "./submitEmail.case";
export var getMapStateToEmailPopupProps = function getMapStateToEmailPopupProps(_ref) {
  var getContent = _ref.getContent,
    submitPayment = _ref.submitPayment,
    setUserAccountInfo = _ref.setUserAccountInfo,
    getUserAccountInfo = _ref.getUserAccountInfo,
    getIsBeelineError = _ref.getIsBeelineError,
    getIsMobile = _ref.getIsMobile;
  return function (getState, setState) {
    var state = getState();
    if (!state.scenario || state.scenario.type !== 'email') return undefined;
    var content = getContent();
    var submitHandler = function submitHandler() {
      return submitEmailUseCase({
        getContent: getContent,
        getIsBeelineError: getIsBeelineError,
        getIsMobile: getIsMobile,
        getUserAccountInfo: getUserAccountInfo,
        setUserAccountInfo: setUserAccountInfo,
        submitPayment: submitPayment
      })(getState, setState).catch(console.error);
    };
    return {
      title: content.emailPopup.title,
      inputProps: {
        label: content.emailPopup.emailInput.label,
        placeholder: content.emailPopup.emailInput.placeholder,
        error: state.scenario.emailInput.errorMessage,
        onChange: function onChange(input) {
          inputEmailUseCase(input !== null && input !== void 0 ? input : '', setState);
        },
        onEnter: submitHandler,
        onBlur: function onBlur() {},
        value: state.scenario.emailInput.value
      },
      buttonProps: {
        onClick: submitHandler,
        children: content.emailPopup.buttonText
      },
      onClose: function onClose() {
        setState(produce(function (draft) {
          draft.scenario = undefined;
        }));
      }
    };
  };
};